import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges, ViewEncapsulation
} from "@angular/core";
import * as _ from "lodash";
import {
  CdkDrag,
  CdkDragDrop,
  CdkDragEnter,
  CdkDropList,
  moveItemInArray,
  transferArrayItem
} from "@angular/cdk/drag-drop";
import { TaskType } from "../../../../tasks/types/task.type";
import { TaskPurposeType } from "../../../../commons/types/task-purpose.type";

require('./route-editable-list.scss');
@Component({
  standalone: false,
  selector: 'app-route-editable-list',
  templateUrl: './route-editable-list.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RouteEditableListComponent implements OnInit {

  @Input() route: any;
  @Input() tasks: any;
  @Input() isLoading: boolean;
  @Output() onMove = new EventEmitter();
  public TaskType = TaskType;
  public TaskPurposeType = TaskPurposeType;

  constructor(@Inject('$timeout') private $timeout, @Inject('planningAlertsService') private planningAlertsService) {
  }

  ngOnInit() {
    this.sortPredicate = this.sortPredicate.bind(this)
  }

  sortPredicate(index: number, item: CdkDrag<any>, drop: CdkDropList) {
    const purpose = item.data.taskSpec.purpose

    const startIndex = _.findIndex(drop.data, (t: any) => {
      return t.taskType === TaskType.Internal && t.taskSpec.purpose === TaskPurposeType.StartRoute;
    })
    const endIndex = _.findIndex(drop.data, (t: any) => {
      return t.taskType === TaskType.Internal && t.taskSpec.purpose === TaskPurposeType.EndRoute;
    })

    if (((startIndex > -1) && (startIndex >= index)) || ((endIndex > -1) && endIndex <= index)) {
      return false;
    }

    if (purpose === TaskPurposeType.Operation) {
      return true;
    } else {


      const connectedIndexes = [];

      drop.data.forEach((t, i) => {
        const serviceIds = t.serviceIdList || [t.serviceId];
        const itemServiceIds = item.data.serviceIdList || [item.data.serviceId];
        if ((item.data.id !== t.id) && !!_.intersection(serviceIds, itemServiceIds).length) {
          connectedIndexes.push(i)
        }
      })

      if (connectedIndexes.length) {

        let canMove = true;

        if (purpose === TaskPurposeType.Pickup) {
          connectedIndexes.forEach((i) => {
            if (i <= index) {
              canMove = false;
            }
          })
          return canMove;
        }

        if (purpose === TaskPurposeType.Dropoff) {
          connectedIndexes.forEach((i) => {
            if (i >= index) {
              canMove = false;
            }
          })
          return canMove;
        }

      } else {
        return true;
      }

    }

  }

  enter(event: CdkDragEnter) {

  }

  drop(event: CdkDragDrop<string[]>) {

    if (!event.isPointerOverContainer) {
      return false;
    }

    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
    this.onMove.emit(event.container.data);
  }


}
